import { isNotPresent } from "neetocist";
import { Typography } from "neetoui";

const FormError = ({ error }) => {
  if (isNotPresent(error) || typeof error !== "string") return null;

  return (
    <Typography
      className="neeto-ui-input__error"
      data-testid="validation-error-container"
      style="body3"
    >
      {error}
    </Typography>
  );
};

export default FormError;
